<template>
    <div class="form-component min-h-screen flex flex-col flex-wrap">
        <header-component></header-component>
        <section class="form-component__container flex w-4/5 mx-auto flex-grow">
            <div class="flex flex-wrap content-start w-3/5 xl:w-1/2 my-16 xl:my-24">
                <div class="mr-8" v-for="(item, index) in data" :key="index">
                    <h3 class="font-adineue-bold text-lg text-grey-darker pb-1">{{ item.title }}</h3>
                    <div class="form-component__select w-64 px-3 py-4 mt-3 border border-black"
                         v-if="item.type == 'dropdown'">
                        <select :id="item.id"
                                ref="allSelect"
                                class="bg-transparent appearance-none outline-none w-full text-grey-darker uppercase text-bold cursor-pointer"
                                @change="assetNameModelFunction($event)">
                            <option v-for="(business, index) in item.dropdown"
                                    :key="index"
                                    :value="business.name"
                                    :disabled="business.disabled"
                                    :selected="business.selected"
                            >
                                {{ business.name }}
                            </option>
                        </select>
                    </div>
                    <input ref="campaignName" :id="item.id" class="w-64 px-3 py-4 mt-3 text-grey-darker border border-black"
                           v-if="item.type == 'input'"
                           v-model="campaignNameModel"
                           type="text"
                    >
                </div>
            </div>
            <div class="flex flex-col w-2/5 xl:w-1/2 px-8 my-16 xl:my-24">
                <p class="text-grey-darker mb-4 w-4/5">
                    <strong class="font-adineue-bold text-lg uppercase tracking-wide">Campaign identifier :</strong>
                    <input class="font-adihaus-din-regular mt-4 ml-2 bg-transparent text-lg w-full" type="text" v-model="campaignIdentifier">
                </p>
                <p class="text-grey-darker text-xl w-4/5">
                    <strong class="font-adineue-bold text-lg uppercase tracking-wide">Asset Name :</strong>
                    <input id="asset-name-generated" class="font-adihaus-din-regular mt-4  ml-2 bg-transparent text-lg w-full" type="text"
                           v-model="assetName">
                </p>
                <div class="flex flex-col mt-5">
                    <div class="mt-8">
                        <span id="button-copy-asset"
                              class="form-component__button items-center font-adihaus-din-regular text-base font-bold text-white tracking-wide-xl uppercase inline-block bg-grey-darker cursor-pointer p-5"
                              v-on:click="copyToClipboard">Copy asset name</span>
                    </div>
                    <div class="mt-5">
                        <span id="button-reset-asset"
                              class="font-adihaus-din-regular tracking-wide-xl cursor-pointer border-b border-grey-darker uppercase text-xs"
                              v-on:click="resetAssetName">Reset asset name</span>
                    </div>
                </div>
            </div>
        </section>
        <footer-component></footer-component>
    </div>
</template>

<script>
    import JSON from '../assets/data/asset-generator-data'
    import HeaderComponent from '@/components/HeaderComponent'
    import FooterComponent from '@/components/FooterComponent'

    export default {
        name: 'FormComponent',

        components: {
            HeaderComponent,
            FooterComponent
        },

        data() {
            return {
                data: JSON,
                assetNameModel: '',
                campaignNameModel: '',
                assetNameTab: []
            }
        },

        computed: {
            campaignIdentifier: function () {
                let temp = '';

                for (const key in this.assetNameTab) {
                    if (key < 2 && this.assetNameTab[key] != null) {
                        temp = temp + this.assetNameTab[key] + '-';
                    }
                }

                return temp + this.campaignNameModel;
            },
            assetName: function () {
                let temp = '';

                for (const key in this.assetNameTab) {
                    if (key > 1 && this.assetNameTab[key] != null) {
                        temp = temp + this.assetNameTab[key] + '-';
                    }
                }

                return this.campaignIdentifier + '-' + temp.substring(0, temp.length - 1);
            },
        },

        methods: {
            /**
             *  Update asset name tab on change select event
             */
            assetNameModelFunction: function (e) {
                // get current select value
                let select = e.target;
                let val = select.options[select.selectedIndex].value;

                // duplicate asset name tab
                let list = [... this.assetNameTab];

                let cpt = 0;
                // get current tab index from json data
                for (const key in this.data) {
                    if (select.id === key) {
                        list[cpt] = val;
                    }
                    cpt++;
                }

                this.assetNameTab = list;
            },
            /**
             *  Copy to clipboard on click method
             */
            copyToClipboard() {
                let copyText = document.getElementById("asset-name-generated");
                copyText.select();
                document.execCommand("copy");
                // alert(copyText.value);
            },
            /**
             *  Reset asset name on click method
             */
            resetAssetName() {
                this.assetNameTab = [];
                this.campaignNameModel = '';
                this.$refs.campaignName.value = '';

                for (const key of this.$refs.allSelect) {
                    key.selectedIndex = 0;
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    h3 {
        /*margin: 0;*/
    }

    .form-component {
        background: url("../assets/media/images/adidas-bg.png") no-repeat bottom right;

        ::placeholder {
            color: config('colors.grey-darker');
            opacity: 1;
            font-size: 1em;
            text-transform: uppercase;
        }

        &__container {
            max-width: 1600px;
        }

        &__select {
            position: relative;
            margin-bottom: 40px;

            &::after {
                position: absolute;
                top: 50%;
                right: 10px;
                content: '';
                display: block;
                height: 20px;
                width: 25px;
                background: url("../assets/media/images/arrow-down.png") no-repeat center center;
                transform: translateY(-50%);
                z-index: -1;
            }
        }

        &__button {
            &::after {
                content: '';
                display: inline-block;
                vertical-align: bottom;
                height: 20px;
                width: 25px;
                background: url("../assets/media/images/arrow-white.svg") no-repeat center center;
                margin-left: 20px;
            }
        }
    }


</style>
